import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Customers from "@/components/widgets/customers";
import DepositPicker from "@/components/widgets/deposits";
import Loading from "@/components/widgets/Loading.vue";
import moment from "moment";

export default {
  components: {
    DatePicker,
    customers: Customers,
    "deposit-picker": DepositPicker,
    Loading,
  },
  data() {
    return {
      loading: false,
      busy: false,
      isEdit: false,
      invoiceUUID: null,
      isCustomerPopupOpen: false,
      isDepositPopupOpen: false,
      momentFormat: {
        stringify: (date) => (date ? moment(date).format("DD/MM/YYYY") : ""),
      },
      // ประเภท VAT: 1 = แยก VAT, 2 = รวม VAT
      // ใบกำกับภาษีต้องมี VAT เสมอ — ไม่มีตัวเลือก "ไม่มี VAT" (ต่างจากใบมัดจำ DD ที่มี 3 แบบ)
      vatOptions: [
        { value: 1, text: "แยก VAT" },
        { value: 2, text: "รวม VAT" },
      ],
      // วิธีชำระเงิน — เก็บเป็น string ให้ตรงกับใบกำกับตัวอื่น (tax_invoice_fulls เก็บ 'cash')
      paymentOptions: [
        { value: "cash", text: "เงินสด" },
        { value: "cheque", text: "เช็ค" },
        { value: "transfer", text: "โอนเงิน" },
        { value: "credit", text: "เครดิต" },
      ],
      vatRate: 7,
      customer: null,
      form: {
        document_no: "",
        document_date: new Date(),
        vat_type: 1,
        payment_method: null,
        remark: null,
        deposit_document_id: null,
        deposit_document_no: null,
      },
      discount: 0,
      // ยอดรับจริงของใบมัดจำ DD ต้นทาง — ใช้กันเศษปัดทำยอดใบ AI ขยับ ±0.01
      depositRefGrand: null,
      items: [],
      fields: [
        { key: "idx", label: "#", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "description", label: "รายละเอียด", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "length", label: "ความยาว", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "quantity", label: "จำนวน", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "unit_name", label: "หน่วย", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "total_length", label: "ปริมาณรวม", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "unit_price", label: "ราคา/หน่วย", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "total_price", label: "ราคารวม", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "action", label: "#", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
      ],
      // ยอดที่คำนวณได้ (แสดงผลอย่างเดียว — ฝั่ง server คำนวณซ้ำเสมอ)
      itemsTotal: 0, // ยอดรวมรายการก่อนหักส่วนลด
      subtotal: 0,
      vat: 0,
      total: 0,
    };
  },
  mounted() {
    const uuid = this.$route.params.id;
    if (uuid) {
      this.isEdit = true;
      this.invoiceUUID = uuid;
      this.loadInvoice(uuid);
    } else {
      this.addItem();
    }
  },
  methods: {
    toNum(v) {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    },
    round2(n) {
      return Math.round(this.toNum(n) * 100) / 100;
    },
    // วันที่เอกสารเลือกได้ถึงวันนี้ — ห้ามวันอนาคต (ตอนสร้างเลขรันตามเดือนของวันที่)
    // โหมดแก้ไขเปลี่ยนวันได้อิสระ ข้ามเดือนได้ — เลขเอกสารคงเดิมเสมอ ไม่ regen
    disableFutureDates(date) {
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      return date > endOfToday;
    },
    blankRow() {
      return {
        code: null,
        code_description: null,
        sku_id: null,
        description: "",
        length: 0,
        quantity: 1,
        total_length: 1,
        unit_name: "",
        unit_price: 0,
        total_price: 0,
        discount: 0,
        tax_rate: this.vatRate,
      };
    },
    addItem() {
      this.items.push(this.blankRow());
      this.calculateTotals();
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.calculateTotals();
    },
    onCopy(index) {
      const target = this.items[index];
      this.items.splice(index + 1, 0, { ...target });
      this.calculateTotals();
    },
    lengthChanged(event, index) {
      this.items[index].length = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    quantityChanged(event, index) {
      this.items[index].quantity = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    unitPriceChanged(event, index) {
      this.items[index].unit_price = parseFloat(event) || 0;
      this.updateTotals(index);
    },
    // ปริมาณรวม/ราคารวมต่อบรรทัด — สูตรเดียวกับใบกำกับเต็มรูป
    // ความยาว 0 = ไม่คิดความยาว (ใช้จำนวนตรง ๆ), qty 0 มองเป็น 1
    computeLine(item) {
      const len = this.toNum(item.length);
      const qtyRaw = this.toNum(item.quantity !== undefined ? item.quantity : item.qty);
      const qty = qtyRaw === 0 ? 1 : qtyRaw;
      const up = this.toNum(item.unit_price);

      const total_length = len === 0 ? qty : len * qty;
      const total_price = total_length * up;

      return {
        total_length: this.round2(total_length),
        total_price: this.round2(total_price),
      };
    },
    updateTotals(index) {
      const item = this.items[index];
      const { total_length, total_price } = this.computeLine(item);
      item.total_length = total_length;
      item.total_price = total_price;
      this.calculateTotals();
    },
    // คำนวณยอดตาม vat_type — ต้องตรงกับ DepositTaxInvoiceController::computeTotals
    calculateTotals() {
      const vatType = Number(this.form.vat_type);
      const r = this.toNum(this.vatRate) / 100;

      let baseSum = 0;   // รวมฐานก่อน VAT
      let grossSum = 0;  // รวมยอดรวม VAT

      this.items.forEach((item) => {
        // ยึด total_price ที่คำนวณไว้ต่อบรรทัด (ปริมาณรวม × ราคา/หน่วย) แล้วหักส่วนลดบรรทัด
        const amount = this.round2(this.toNum(item.total_price) - this.toNum(item.discount));
        if (vatType === 2) {
          grossSum += amount;
          baseSum += this.round2(amount / (1 + r));
        } else {
          baseSum += amount;
          grossSum += this.round2(amount * (1 + r));
        }
      });

      // ยอดรวมรายการ (ก่อนหักส่วนลด) — type 2 แสดงยอดรวม VAT, นอกนั้นแสดงฐานก่อน VAT
      this.itemsTotal = this.round2(vatType === 2 ? grossSum : baseSum);

      const subtotalRaw = vatType === 2 ? grossSum / (1 + r) : baseSum;
      const discountBeforeVat = vatType === 2 ? this.toNum(this.discount) / (1 + r) : this.toNum(this.discount);

      const baseAfterDiscount = Math.max(subtotalRaw - discountBeforeVat, 0);
      this.subtotal = this.round2(baseAfterDiscount);
      this.vat = vatType === 0 ? 0 : this.round2(baseAfterDiscount * r);
      this.total = this.round2(baseAfterDiscount + this.vat);

      // ถ้าผูก DD ให้ยอดสุทธิของ AI เท่ากับเงินที่รับจริงในใบต้นทาง
      // ปรับเฉพาะเศษสตางค์ เพื่อไม่ล็อกยอดกรณีผู้ใช้แก้รายการจริง
      const sourceGrand = this.toNum(this.depositRefGrand);
      if (
        this.form.deposit_document_id &&
        sourceGrand > 0 &&
        Math.abs(this.total - sourceGrand) <= 0.05
      ) {
        this.total = this.round2(sourceGrand);
        this.vat = this.round2(Math.max(this.total - this.subtotal, 0));
      }
    },
    onOpenCustomer() {
      this.isCustomerPopupOpen = true;
    },
    onCustomerSelected(e) {
      this.isCustomerPopupOpen = false;
      if (!e.status || !e.data) return;

      // เปลี่ยนลูกค้า → ใบมัดจำที่เลือกไว้เป็นของลูกค้าคนเดิม ต้องล้างทิ้ง
      // ไม่งั้นเอกสารจะผูกใบมัดจำผิดคน (เทียบด้วย != กัน id เป็น string/number ปนกัน)
      const changed = this.form.customer_id && this.form.customer_id != e.data.id;
      if (changed && this.form.deposit_document_no) {
        this.clearDeposit();
      }

      this.customer = e.data;
      this.form.customer_id = e.data.id;
    },
    onOpenDeposit() {
      this.isDepositPopupOpen = true;
    },
    // เลือกใบมัดจำอ้างอิง → เติมยอด/ลูกค้าให้อัตโนมัติ (แก้ต่อได้)
    onDepositSelected(e) {
      this.isDepositPopupOpen = false;
      if (!e.status || !e.data) return;

      const dep = e.data;
      this.form.deposit_document_id = dep.id;
      this.form.deposit_document_no = dep.document_no;

      if (dep.customer) {
        this.customer = dep.customer;
        this.form.customer_id = dep.customer.id;
      } else if (dep.customer_id) {
        this.form.customer_id = dep.customer_id;
      }

      // ใบมัดจำเก็บ tax_type ไว้ (0/1/2) — ยึดตามใบต้นทาง แต่ใบกำกับต้องมี VAT เสมอ
      // ใบมัดจำแบบไม่มี VAT (0) → default เป็นแยก VAT ให้ผู้ใช้เลือกต่อ
      if (dep.tax_type !== undefined && dep.tax_type !== null) {
        const t = Number(dep.tax_type);
        this.form.vat_type = t === 2 ? 2 : 1;
      }

      // ยอดตั้งต้น: type 2 ใช้ยอดรวม VAT, นอกนั้นใช้ฐานก่อน VAT
      const amount = Number(this.form.vat_type) === 2
        ? this.toNum(dep.grand_total || dep.amount)
        : this.toNum(dep.before_vat || dep.amount);
      this.depositRefGrand = this.toNum(dep.grand_total ?? dep.amount);

      this.items = [{
        ...this.blankRow(),
        description: "มัดจำค่าสินค้า",
        unit_name: "งาน",
        unit_price: amount,
        total_price: this.round2(amount),
      }];
      this.calculateTotals();
    },
    clearDeposit() {
      this.form.deposit_document_id = null;
      this.form.deposit_document_no = null;
      this.depositRefGrand = null;
      this.calculateTotals();
    },
    async loadInvoice(uuid) {
      try {
        this.loading = true;
        const url = `${Vue.prototype.$host}/api/v1/document/deposit-tax-invoice/${uuid}`;
        const res = await Vue.prototype.$axios.get(url);
        this.loading = false;

        const inv = res?.data?.data;
        if (!inv) {
          this.onExceptionHandler("ไม่พบใบกำกับภาษีมัดจำ");
          return;
        }

        this.form.document_no = inv.document_no || "";
        this.form.document_date = inv.document_date ? new Date(inv.document_date) : null;
        this.form.vat_type = Number(inv.vat_type ?? 1);
        this.form.payment_method = inv.payment_method;
        this.form.remark = inv.remark;
        this.form.customer_id = inv.customer_id;
        this.form.deposit_document_id = inv.deposit_document_id;
        this.form.deposit_document_no = inv.deposit_document_no;
        this.depositRefGrand = inv.deposit_document
          ? this.toNum(inv.deposit_document.grand_total ?? inv.deposit_document.amount)
          : null;
        this.vatRate = this.toNum(inv.vat_rate) || 7;
        this.discount = this.toNum(inv.discount);
        this.customer = inv.customer_detail || null;

        this.items = (inv.items || []).map((it) => {
          const row = {
            code: it.code,
            code_description: it.code_description,
            sku_id: it.sku_id,
            description: it.description || "",
            length: this.toNum(it.length),
            quantity: this.toNum(it.qty),
            unit_name: it.unit_name || "",
            unit_price: this.toNum(it.unit_price),
            discount: this.toNum(it.discount),
            tax_rate: this.toNum(it.tax_rate) || this.vatRate,
          };
          // คิดปริมาณรวม/ราคารวมใหม่จากฐาน (กันค่าที่เก็บไว้ไม่ตรงสูตรปัจจุบัน)
          const { total_length, total_price } = this.computeLine(row);
          return { ...row, total_length, total_price };
        });

        this.$nextTick(() => this.calculateTotals());
      } catch (err) {
        this.loading = false;
        this.onExceptionHandler(
          err?.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    validate() {
      if (!this.form.customer_id) {
        this.onExceptionHandler("กรุณาเลือกลูกค้า");
        return false;
      }
      if (!this.form.document_date) {
        this.onExceptionHandler("กรุณาเลือกวันที่เอกสาร");
        return false;
      }
      const valid = this.items.filter(
        (i) => (i.description || "").trim() !== "" || this.toNum(i.unit_price) !== 0 || this.toNum(i.total_price) !== 0
      );
      if (!valid.length) {
        this.onExceptionHandler("กรุณาใส่รายการอย่างน้อย 1 รายการ");
        return false;
      }
      return true;
    },
    onConfirm() {
      if (!this.validate()) return;

      this.$swal({
        title: "แจ้งเตือน",
        text: this.isEdit
          ? "ต้องการบันทึกการแก้ไขใบกำกับภาษีมัดจำนี้หรือไม่"
          : "ต้องการสร้างใบกำกับภาษีมัดจำนี้หรือไม่",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#dc4a38",
      }).then((result) => {
        if (result.value) this.submit();
      });
    },
    async submit() {
      try {
        this.busy = true;
        const payload = {
          document_date: moment(this.form.document_date).format("YYYY-MM-DD"),
          customer_id: this.form.customer_id,
          deposit_document_id: this.form.deposit_document_id,
          vat_type: this.form.vat_type,
          vat_rate: this.vatRate,
          discount: this.toNum(this.discount),
          payment_method: this.form.payment_method,
          remark: this.form.remark,
          items: JSON.stringify(this.items),
        };

        const base = `${Vue.prototype.$host}/api/v1/document/deposit-tax-invoice`;
        if (this.isEdit) {
          await Vue.prototype.$axios.put(`${base}/${this.invoiceUUID}`, payload);
        } else {
          await Vue.prototype.$axios.post(base, payload);
        }

        this.busy = false;
        this.$swal({
          title: "สำเร็จ",
          text: "บันทึกข้อมูลเรียบร้อย",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        setTimeout(() => this.$router.push("/tax/deposit"), 1200);
      } catch (error) {
        this.busy = false;
        this.onExceptionHandler(
          error?.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    oncancel() {
      this.$router.push("/tax/deposit");
    },
  },
  watch: {
    "form.vat_type"() {
      this.calculateTotals();
    },
    discount() {
      this.calculateTotals();
    },
  },
};
